import { render, staticRenderFns } from "./customMade-qrcode.vue?vue&type=template&id=a538a3b4"
import script from "./customMade-qrcode.vue?vue&type=script&lang=ts"
export * from "./customMade-qrcode.vue?vue&type=script&lang=ts"
import style0 from "./customMade-qrcode.vue?vue&type=style&index=0&id=a538a3b4&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports